import React from "react";
import Box from "@material-ui/core/Box";
import {
  getWhatsAppProviderIcon,
  getWhatsAppProviderLabel,
} from "../../constants/whatsappProviders";

/**
 * Logo del canal de una conexión (WhatsApp, WABA, Messenger, Instagram).
 *
 * WHY existe: el menú de alta, la tarjeta de conexión y el chip del ticket pintaban los
 * cuatro canales con el MISMO icono de WhatsApp, cambiando solo el color. Con seis entradas
 * en el menú el usuario veía seis logos de WhatsApp de colores distintos.
 *
 * Centralizar el `<img>` evita que cada sitio reinvente el tamaño, el `alt` y el fallback.
 * La ruta y la etiqueta salen de `constants/whatsappProviders` — un canal nuevo se declara
 * una vez y aparece en los tres sitios.
 *
 * @param {string} provider — "baileys" | "evolution" | "waba" | "facebook" | "instagram"
 * @param {number} size     — lado en px (cuadrado)
 */
const ChannelIcon = ({ provider, size = 22, style, className, ...rest }) => (
  <Box
    component="img"
    src={getWhatsAppProviderIcon(provider)}
    alt={getWhatsAppProviderLabel(provider)}
    title={getWhatsAppProviderLabel(provider)}
    className={className}
    style={{
      width: size,
      height: size,
      // Los logos ya son cuadrados con alfa; `contain` protege de un PNG futuro que no lo sea.
      objectFit: "contain",
      flexShrink: 0,
      ...style,
    }}
    {...rest}
  />
);

export default ChannelIcon;
